import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import fatcaQuestionnaireType from '../../life-config/fatcaQuestionConfig.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { ApiService } from '../../services/api.service';
import { map, startWith } from 'rxjs/operators';
import { SharedApiService } from '../../services/shared-api.service';
import { CountryInfo } from '../../model/data.model';
import trackingInfo from '../../life-config/journey-tracker.json';

@Component({
  selector: 'app-hypertension',
  templateUrl: './hypertension.component.html',
  styleUrls: ['./hypertension.component.css']
})
export class HypertensionComponent implements OnInit {


    occQuestionnaireForm: FormGroup;
    hyperTesnionQuestionnaireDetails: object = fatcaQuestionnaireType.hypertensionQuestion;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    trackInfo: object = trackingInfo['tracker-info'];
    birthCountryList: any;
    citizenCountryList: any;
    companyList: any;
    addressCountryList: any;
    taxResidencyCountry: any;
    addressStateList: any;
    addResidencyState: any;
    addressCityList: any;
    addressPincode: any;
    mergedCovidData: any;
    defenceData: any;
    occupdationData: any;
    proposalRes: any;
    fatcaData: any;
    finalDataToSend: any;
    tabListData: any;
    isLeftSectionLoader = false;
    isLoaderActivated = false;
    uuid: string;
    proposalId: string;
    productType: object = lifeProductType.product_type;
    BPMaxdate: any;
    BPMinDate: any;
    hyperTensionData: any;

  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private sharedData: SharedApiService,
    private formbuild: FormBuilder) {

        this.occQuestionnaireForm = this.formbuild.group({

            /**
             * Occupation
             */

            elevatedBPDate: ['', Validators.required],
            BPLevel: ['', [
                Validators.required,
                Validators.min(1),
                Validators.max(50),
                ]],
                docNoAdd: ['', [
                    Validators.required,
                    Validators.maxLength(100)
                ]],
                followUpDoctor: ['', [
                    Validators.required,
                    Validators.maxLength(50)
                ]],
                hypertensionAsConsidered: [this.hyperTesnionQuestionnaireDetails['hypertensionAsConsidered']['default']] ,

                hypertensionAsConsideredDesc: [],
                compilationsHrtKdny: [this.hyperTesnionQuestionnaireDetails['compilationsHrtKdny']['default']],
                compilationsHrtKdnyDesc: [],
                onTrtment: [this.hyperTesnionQuestionnaireDetails['onTrtment']['default']] ,
                onTrtmentDesc: [],
                discontinuedMedicalTrmnt: [this.hyperTesnionQuestionnaireDetails['discontinuedMedicalTrmnt']['default']],
                discontinuedMedicalTrmntDesc: [],
                stillTreatment: [this.hyperTesnionQuestionnaireDetails['stillTreatment']['default']],
                stillTreatmentDesc: [],
                ecgInvst: [this.hyperTesnionQuestionnaireDetails['ecgInvst']['default']],
                ecgInvstDesc: [],
                investigationResult: [],
                investigationResultDesc: [],
                recentBloodPressureLevel: ['', [Validators.required ,    Validators.max(200)]],
                recentBPDate: ['', Validators.required],
                BPinTweleveMonths: ['', [Validators.required, Validators.max(200)]],
                BPTwelveDate: ['', [Validators.required ]],
                informedToConcern: [false],
                abnormalities: [this.hyperTesnionQuestionnaireDetails['hypertensionAsConsidered']['default']],
                abnormalitiesDesc: [],
                lostSignificantTime: [this.hyperTesnionQuestionnaireDetails['lostSignificantTime']['default']],
                lostSignificantTimeDesc: [],
                acceptDeclaration: []

        });

        this.BPMinDate = new Date();
        this.BPMaxdate = new Date('01-01-1920');

        this.sharedData.tabEventData.subscribe(value => {
            if (value) {

                this.tabListData = value;


            }
        });

        this.apiService.getStatusEvent.subscribe(value => {

            if (value) {
                const errorStatusFromApi = value['status'];

                if ( errorStatusFromApi === 400 ) {

                    this.isLoaderActivated = false;
                }
            }


        });
     }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.proposalId = params['proposalId'];
        });

        // Get propsoal info

        if (this.uuid && this.proposalId) {

            this.isLeftSectionLoader = true;
            this.sharedData.getProposalInfo(this.proposalId, this.uuid).subscribe(res => {
                if (res) {

                    this.proposalRes = res;


                    if (this.proposalRes) {

                        this.feedProposalData();


                    }
                    this.hypertensionAsConsidereValidation();
                    this.compilationsHrtKdnyValidation();
                    this.onTrtmentValidation();
                    this.discontinuedMedicalTrmntValidation();
                    this.stillTreatmentValidation();
                    this.ecgInvstValidation();
                    this.abnormalitiesValidation();
                    this.lostSignificantTimeValidation();
                }

            });

        }
    }


    feedProposalData() {

        this.tabListData = this.sharedData.storeTabInfo();


        this.occQuestionnaireForm.patchValue({ elevatedBPDate: this.proposalRes['questions']['bp_diagnosed'] });
        this.occQuestionnaireForm.patchValue({ BPLevel: this.proposalRes['questions']['bp_level'] });
        this.occQuestionnaireForm.patchValue({ docNoAdd: this.proposalRes['questions']['bp_consulted_doctor'] });
        this.occQuestionnaireForm.patchValue({ followUpDoctor: this.proposalRes['questions']['follow_up_doctor'] });
        this.occQuestionnaireForm.patchValue({ hypertensionAsConsidered: this.proposalRes['questions']['hypertension_secondary'] });
        this.occQuestionnaireForm.patchValue({ compilationsHrtKdny: this.proposalRes['questions']['other_complications'] });
        this.occQuestionnaireForm.patchValue({ onTrtment: this.proposalRes['questions']['bp_treatment'] });
        this.occQuestionnaireForm.patchValue({ discontinuedMedicalTrmnt: this.proposalRes['questions']['failed_discontinued'] });
        this.occQuestionnaireForm.patchValue({ stillTreatment: this.proposalRes['questions']['still_treatment'] });
        this.occQuestionnaireForm.patchValue({ ecgInvst: this.proposalRes['questions']['undergone_investigation'] });
        
        this.occQuestionnaireForm.patchValue({ recentBloodPressureLevel: this.proposalRes['questions']['bp_calculate'] });
        this.occQuestionnaireForm.patchValue({ recentBPDate: this.proposalRes['questions']['bp_date'] });
        this.occQuestionnaireForm.patchValue({ BPinTweleveMonths: this.proposalRes['questions']['bp_twelve_months'] });
        this.occQuestionnaireForm.patchValue({ BPTwelveDate: this.proposalRes['questions']['bp_twelve_date'] });

        this.occQuestionnaireForm.patchValue({ informedToConcern: this.proposalRes['questions']['bp_raised'] });
        this.occQuestionnaireForm.patchValue({ abnormalities: this.proposalRes['questions']['bp_abnormalities'] });
        this.occQuestionnaireForm.patchValue({ lostSignificantTime: this.proposalRes['questions']['bp_off_work'] });


        if (this.occQuestionnaireForm.get('hypertensionAsConsidered').value) {

            this.occQuestionnaireForm.patchValue(
                { hypertensionAsConsideredDesc: this.proposalRes['questions']['hypertension_secondary_detail'] });
        }


        if (this.occQuestionnaireForm.get('compilationsHrtKdny').value) {

            this.occQuestionnaireForm.patchValue({ compilationsHrtKdnyDesc: this.proposalRes['questions']['other_complications_detail'] });
        }

        if (this.occQuestionnaireForm.get('onTrtment').value) {

            this.occQuestionnaireForm.patchValue({ onTrtmentDesc: this.proposalRes['questions']['bp_treatment_date'] });

        }


        if (this.occQuestionnaireForm.get('discontinuedMedicalTrmnt').value) {

            this.occQuestionnaireForm.patchValue(
                { discontinuedMedicalTrmntDesc: this.proposalRes['questions']['failed_discontinued_detail'] });
        }


        if (this.occQuestionnaireForm.get('stillTreatment').value) {

            this.occQuestionnaireForm.patchValue({ stillTreatmentDesc: this.proposalRes['questions']['still_treatment_detail'] });
        }

        if ( this.occQuestionnaireForm.get('ecgInvst').value) {


            this.occQuestionnaireForm.patchValue({ ecgInvstDesc: this.proposalRes['questions']['undergone_investigation_detail'] });
            this.occQuestionnaireForm.patchValue({ investigationResult: this.proposalRes['questions']['investigation_result'] });

        }

        if ( this.occQuestionnaireForm.get('abnormalities').value) {


            this.occQuestionnaireForm.patchValue({ abnormalitiesDesc: this.proposalRes['questions']['bp_abnormalities_detail'] });


        }


        if ( this.occQuestionnaireForm.get('lostSignificantTime').value) {



            this.occQuestionnaireForm.patchValue({ lostSignificantTimeDesc: this.proposalRes['questions']['bp_off_work_detail'] });

        }


        /**
         * loader will come at last after all data has been feed
         */
        this.isLeftSectionLoader = false;

    }


    saveOccupationFormData(isValid: boolean) {

        if (isValid) {
            this.isLoaderActivated = true;
            const primarilyData = {
                bp_diagnosed : this.datePipe.transform(new Date(this.occQuestionnaireForm.get('elevatedBPDate').value), 'yyyy-MM-dd'),
                bp_level : this.occQuestionnaireForm.get('BPLevel').value,
                bp_consulted_doctor: this.occQuestionnaireForm.get('docNoAdd').value,
                follow_up_doctor: this.occQuestionnaireForm.get('followUpDoctor').value,
                hypertension_secondary: this.occQuestionnaireForm.get('hypertensionAsConsidered').value,
                other_complications: this.occQuestionnaireForm.get('compilationsHrtKdny').value,
                bp_treatment: this.occQuestionnaireForm.get('onTrtment').value,
                failed_discontinued:  this.occQuestionnaireForm.get('discontinuedMedicalTrmnt').value,
                still_treatment: this.occQuestionnaireForm.get('stillTreatment').value,
                undergone_investigation: this.occQuestionnaireForm.get('ecgInvst').value,
                bp_calculate: this.occQuestionnaireForm.get('recentBloodPressureLevel').value,
                bp_date: this.datePipe.transform(new Date(this.occQuestionnaireForm.get('recentBPDate').value), 'yyyy-MM-dd'),
                bp_twelve_months: this.occQuestionnaireForm.get('BPinTweleveMonths').value,
                bp_twelve_date: this.datePipe.transform(new Date(this.occQuestionnaireForm.get('BPTwelveDate').value), 'yyyy-MM-dd'),
                bp_raised: this.occQuestionnaireForm.get('informedToConcern').value,
                bp_abnormalities: this.occQuestionnaireForm.get('abnormalities').value,
                bp_off_work: this.occQuestionnaireForm.get('lostSignificantTime').value
            };

            this.hyperTensionData = primarilyData;

            if (this.occQuestionnaireForm.get('hypertensionAsConsidered').value) {

                const hypdesc = {

                    hypertension_secondary_detail: this.occQuestionnaireForm.get('hypertensionAsConsideredDesc').value



                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);
            }


            if (this.occQuestionnaireForm.get('compilationsHrtKdny').value) {

                const hypdesc = {

                    other_complications_detail: this.occQuestionnaireForm.get('compilationsHrtKdnyDesc').value

                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);
            }

            if (this.occQuestionnaireForm.get('onTrtment').value) {

                const hypdesc = {

                    bp_treatment_date: this.datePipe.transform(
                        new Date(this.occQuestionnaireForm.get('onTrtmentDesc').value), 'yyyy-MM-dd'),

                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);
            }


            if (this.occQuestionnaireForm.get('onTrtment').value) {

                const hypdesc = {

                    bp_treatment_date: this.datePipe.transform(
                        new Date(this.occQuestionnaireForm.get('onTrtmentDesc').value), 'yyyy-MM-dd'),

                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);
            }


            if (this.occQuestionnaireForm.get('discontinuedMedicalTrmnt').value) {

                const hypdesc = {

                    failed_discontinued_detail: this.occQuestionnaireForm.get('discontinuedMedicalTrmntDesc').value
                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);
            }


            if (this.occQuestionnaireForm.get('stillTreatment').value) {

                const hypdesc = {

                    still_treatment_detail: this.occQuestionnaireForm.get('stillTreatmentDesc').value
                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);
            }

            if ( this.occQuestionnaireForm.get('ecgInvst').value) {

                const hypdesc = {

                    undergone_investigation_detail: this.occQuestionnaireForm.get('ecgInvstDesc').value,
                    investigation_result: this.occQuestionnaireForm.get('investigationResult').value,
                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);

            }

            if ( this.occQuestionnaireForm.get('abnormalities').value) {

                const hypdesc = {

                    bp_abnormalities_detail: this.occQuestionnaireForm.get('abnormalitiesDesc').value
                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);

            }


            if ( this.occQuestionnaireForm.get('lostSignificantTime').value) {

                const hypdesc = {

                    bp_off_work_detail: this.occQuestionnaireForm.get('lostSignificantTimeDesc').value
                };


                this.hyperTensionData = Object.assign({}, this.hyperTensionData, hypdesc);

            }

            const mergedObjectInfoData: any = {

                questions: Object.assign({},   this.hyperTensionData),
                journey_track: this.trackInfo['QUESTIONNAIRE']
            };

            this.finalDataToSend =  Object.assign({}, mergedObjectInfoData);

            this.apiService.updateProposal(
                this.apiUrl['apiV2LifeProposal'],
                this.proposalId, this.uuid,
                this.apiUrl['update_proposal'],
                this.finalDataToSend).subscribe(res => {

                if (res) {

                    this.isLoaderActivated = false;

                    if (this.tabListData && this.tabListData.length > 1) {

                        this.tabListData.forEach((element, index) => {
                            if (element['type'] === 'hypertension') {

                                if (index < (this.tabListData.length) - 1) {

                                    this.sharedData.getNextCrntActiveTab(this.tabListData[index + 1] , 0);
                                } else {

                                    this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                                }
                            }

                         });




                    } else {

                        this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                    }
                }

            },
                err => {
                    console.log('sonething went at our end', err);
                });
        }

    }


    hypertensionAsConsidereValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('hypertensionAsConsideredDesc');


        this.occQuestionnaireForm.get('hypertensionAsConsidered').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required,  Validators.maxLength(150),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$')) ]);

                }

                if (!criminalMode) {

                    isHyperTension.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();

            });
    }

    compilationsHrtKdnyValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('compilationsHrtKdnyDesc');


        this.occQuestionnaireForm.get('compilationsHrtKdny').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required,  Validators.maxLength(150),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))  ]);

                }

                if (!criminalMode) {

                    isHyperTension.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();

            });
    }

    onTrtmentValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('onTrtmentDesc');


        this.occQuestionnaireForm.get('onTrtment').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required ]);

                }

                if (!criminalMode) {

                    isHyperTension.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();

            });
    }

    discontinuedMedicalTrmntValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('discontinuedMedicalTrmntDesc');


        this.occQuestionnaireForm.get('discontinuedMedicalTrmnt').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required,  Validators.maxLength(150),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))  ]);

                }

                if (!criminalMode) {

                    isHyperTension.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();

            });
    }

    stillTreatmentValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('stillTreatmentDesc');


        this.occQuestionnaireForm.get('stillTreatment').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required,  Validators.maxLength(150),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))  ]);

                }

                if (!criminalMode) {

                    isHyperTension.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();

            });
    }

    ecgInvstValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('ecgInvstDesc');
        const isInvst = this.occQuestionnaireForm.get('investigationResult');


        this.occQuestionnaireForm.get('ecgInvst').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required,  Validators.maxLength(150),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))  ]);

                    isInvst.setValidators([Validators.required, Validators.maxLength(150) ]);

                }

                if (!criminalMode) {

                    isHyperTension.setValidators([]);
                    isInvst.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();
                isInvst.updateValueAndValidity();

            });
    }

    abnormalitiesValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('abnormalitiesDesc');


        this.occQuestionnaireForm.get('abnormalities').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required, Validators.maxLength(150),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))  ]);

                }

                if (!criminalMode) {

                    isHyperTension.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();

            });
    }

    lostSignificantTimeValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('lostSignificantTimeDesc');


        this.occQuestionnaireForm.get('lostSignificantTime').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required,  Validators.maxLength(100),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))  ]);

                }

                if (!criminalMode) {

                    isHyperTension.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();

            });
    }

    backBtnFromRoutes() {
        this.router.navigate(['/life/upload-document', this.proposalId, this.uuid])
        .then(() => {
            window.location.reload();
        });

    }

}
